var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import Validation from "@irati/utils/validation";
import { OverlayPlacement } from "@irati/ui/src/Tooltip/Overlay";
import { StyledTextArea, StyledFormGroup, StyledIconTooltip } from "./styled";
var MAX_CHAR_LENGTH = 55;
var schema = function (formatMessage) { return Validation.string(formatMessage({ id: "platform.defaultValidation.required" })); };
var CompanyNewsDescriptionInput = /** @class */ (function (_super) {
    __extends(CompanyNewsDescriptionInput, _super);
    function CompanyNewsDescriptionInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyNewsDescriptionInput.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, onChange = _a.onChange, value = _a.value;
        return (React.createElement(StyledFormGroup, null,
            React.createElement(StyledTextArea, { label: React.createElement(React.Fragment, null,
                    React.createElement(FormattedMessage, { id: "platform.homepage.fields.description.label" }),
                    React.createElement(StyledIconTooltip, { placement: OverlayPlacement.Bottom },
                        React.createElement(FormattedMessage, { id: "platform.homepage.fields.description.tooltip" }))), maxLength: MAX_CHAR_LENGTH, name: "description", onChange: onChange, rows: 4, validation: schema(formatMessage), value: value })));
    };
    return CompanyNewsDescriptionInput;
}(PureComponent));
export default injectIntl(CompanyNewsDescriptionInput);
